import { RAPORSEMKOLAB_GET } from './reduxConstant';
import { createReducer } from '../../../../common/util/reducerUtils';

const initialState = [];

const raporsemkolabGet = (state, payload) => {
  return [...payload.raporsemkolab];
};

export default createReducer(initialState, {
  [RAPORSEMKOLAB_GET]: raporsemkolabGet,
});
